import { render, staticRenderFns } from "./AdminType.vue?vue&type=template&id=feed79f6&scoped=true&"
import script from "./AdminType.vue?vue&type=script&lang=js&"
export * from "./AdminType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feed79f6",
  null
  
)

export default component.exports